import { array, boolean, defineAction, number, object, string } from '~/prix'
import systemImportFailureReporterAction from './systemImportFailureReporter.action.json' assert { type: 'json' }

const systemImportFailureReporterDefinition = defineAction({
  ...systemImportFailureReporterAction,
  input: object({
    generateHtmlFile: boolean().isOptional(),
  }),
  output: object({
    alertsSent: number(),
    problematicImportsCount: number(),
    problematicImports: array(
      object({
        actionKey: string(),
        dataset: string(),
        hoursSinceLastRun: number().isOptional(),
        reason: string(),
        lastSuccessfulRun: string().isOptional(),
        lastUnsuccessfulRun: string().isOptional(),
        wasLastRunSuccessful: string(),
        nextRun: string().isOptional(),
      }),
    ),
    warnings: array(
      object({
        message: string(),
      }),
    ),
    htmlFilePath: string().isOptional(),
  }),
})

export default systemImportFailureReporterDefinition
